import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
// import PrivateApp from "./PrivateApp";
import PublicApp from './PublicApp';
import * as serviceWorker from "./serviceWorker";

// if (process.env.REACT_APP_PUBLIC === "private") {
//   ReactDOM.render(<PrivateApp />, document.getElementById("root"));
// } else if (process.env.REACT_APP_PUBLIC === "public") {
ReactDOM.render(<PublicApp />, document.getElementById("root"));
// } else {
//   throw Error("Please set the environment variable for making the site private or public facing!")
// }

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
